<!-- Header -->
<header class="n-header">
  <div class="n-header-content">
    <div class="n-logo">
      <img src="assets/img/logo-portal-dark.png" alt="Logo Portal" />
    </div>
    <button
      class="n-profile-btn"
      (click)="menu.toggle($event)"
      pRipple
      [attr.aria-label]="'Abrir menu do usuário'">
      <p-avatar
        [image]="userAvatarUrl"
        shape="circle"
        size="normal"
        [label]="userAvatarUrl ? '' : 'U'"
        [style]="!userAvatarUrl ? {'background-color': '#1720c7', 'color': 'white'} : {}">
      </p-avatar>
      <i class="pi pi-angle-down" aria-hidden="true"></i>
    </button>
  </div>
</header>

<!-- Main Content -->
<main class="n-main">
  <div class="n-container">

    <!-- Title Section -->
    <div class="n-title-section">
      <h1 class="n-main-title">Qual sistema você quer acessar?</h1>
      <p class="n-subtitle">Escolha a plataforma ideal para suas necessidades</p>
    </div>

    <!-- Systems Grid -->
    <div class="n-systems-grid">

      <!-- Portal System -->
      <!-- <article class="n-system-card n-portal"
               (click)="acessarPortal()"
               (keydown.enter)="acessarPortal()"
               (keydown.space)="acessarPortal()"
               tabindex="0"
               role="button"
               [attr.aria-label]="'Acessar Portal - Gerencie seu perfil e configurações'"
               pRipple>
        <div class="n-card-glow" aria-hidden="true"></div>
        <div class="n-card-content">
          <div class="n-system-icon" aria-hidden="true">
            <img src="assets/img/logo-portal-light.png" alt="" />
          </div>
          <div class="n-system-info">
            <h3 class="n-system-name">Portal</h3>
            <p class="n-system-desc">Gerencie seu perfil e configurações</p>
            <div class="n-system-badge">
              <span>Perfil Pessoal</span>
            </div>
          </div>
          <div class="n-card-arrow" aria-hidden="true">
            <i class="pi pi-arrow-right"></i>
          </div>
        </div>
        <div class="n-hover-effect" aria-hidden="true"></div>
      </article> -->

      <!-- Bardo System -->
      <article class="n-system-card n-bardo"
               (click)="acessarBardo()"
               (keydown.enter)="acessarBardo()"
               (keydown.space)="acessarBardo()"
               tabindex="0"
               role="button"
               [attr.aria-label]="'Acessar Bardo - Sistema de agendamentos inteligente'"
               pRipple>
        <div class="n-card-glow" aria-hidden="true"></div>
        <div class="n-card-content">
          <div class="n-system-icon" aria-hidden="true">
            <img src="assets/img/logo-bardo-light.png" alt="" />
          </div>
          <div class="n-system-info">
            <h3 class="n-system-name">Bardo</h3>
            <p class="n-system-desc">Sistema de agendamentos inteligente</p>
            <div class="n-system-badges">
              <span class="n-badge">Admin</span>
              <span class="n-badge">Cliente</span>
              <span class="n-badge">Profissional</span>
            </div>
          </div>
          <div class="n-card-arrow" aria-hidden="true">
            <i class="pi pi-arrow-right"></i>
          </div>
        </div>
        <div class="n-hover-effect" aria-hidden="true"></div>
      </article>

    </div>

  </div>
</main>

<!-- User Menu -->
<p-menu #menu
        [popup]="true"
        [model]="menuItems"
        styleClass="n-user-menu"
        [attr.aria-label]="'Menu do usuário'"></p-menu>

<!-- Loading Overlay -->
@if (isLoading) {
  <div class="n-loading-overlay"
       role="dialog"
       aria-modal="true"
       [attr.aria-label]="'Carregando sistema'">
    <div class="n-loading-content">
      <div class="n-spinner"
           role="status"
           aria-label="Carregando"></div>
      <p>Redirecionando...</p>
    </div>
  </div>
}

